module.exports = __webpack_public_path__ + "img/m03.4bf0929d.png";